import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import OverlayPortalContainer from "./Container"; // 1: Renders a React Portal into document.body to avoid component hierarchy and potential overflow issues
// 2: Receives positional values of tooltip trigger from ref and applies positioning to the overlay
// 3: Renders nothing if scroll event fires on window. Avoids potential bug of tooltip staying still while trigger moves.

var propTypes = {
  overlayPosition: PropTypes.shape({
    width: PropTypes.number,
    height: PropTypes.number,
    top: PropTypes.number,
    left: PropTypes.number
  }),
  children: PropTypes.node,
  closeOverlay: PropTypes.func
};
var defaultProps = {
  overlayPosition: {
    width: 0,
    height: 0,
    top: 0,
    left: 0
  }
};
export default function OverlayPortal(props) {
  useEffect(function () {
    window.addEventListener('scroll', props.closeOverlay, true);
    return function () {
      window.removeEventListener('scroll', props.closeOverlay, true);
    };
  });
  return ReactDOM.createPortal(React.createElement(OverlayPortalContainer, props), document.body);
}
OverlayPortal.propTypes = propTypes;
OverlayPortal.defaultProps = defaultProps;